import React, { useState } from 'react'

import { CreateToolbar, AsidePreview, CreateForm } from './containers'

export const CreateStylesheet = (props: any) => {
  const {
    showAside = false,
    shouldRedirect = true,
    closeDrawer = false,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
  } = props

  const [formData, setFormData] = useState([])

  return (
    <>
      <CreateForm
        {...props}
        setFormData={setFormData}
        toolbar={<CreateToolbar closeDrawer={closeDrawer} />}
        aside={showAside ? <AsidePreview formData={formData} /> : <></>}
        onSubmitSuccess={onSubmitSuccess}
        onSubmitFailure={onSubmitFailure}
        shouldRedirect={shouldRedirect}
        resource="cms/content/stylesheets"
      />
    </>
  )
}
